import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

class News {
  $container: JQuery<HTMLElement>;
  $btns: JQuery<HTMLElement>;
  $items: JQuery<HTMLElement>;

  constructor() {
    this.$container = $('.news');
    this.$btns = this.$container.find('.news__btn');
    this.$items = this.$container.find('.news__item');

    this.bindEvents();
  }

  bindEvents() {
    this.$btns.on('click', this.handleClick.bind(this));
  }

  handleClick(e: JQuery.ClickEvent) {
    const $btn = $(e.currentTarget);
    const type = $btn.data('type');

    if (!$btn.hasClass('is-active')) {
      this.$btns.removeClass('is-active');
      $btn.addClass('is-active');

      const state = Flip.getState(this.$items.get());

      if (type === 'all') {
        this.$items.css('display', 'grid');
      } else {
        this.$items.each((index, item) => {
          const $item = $(item);
          const isMatch = $item.data('type') === type;

          $item.css('display', isMatch ? 'grid' : 'none');
        });
      }

      Flip.from(state, {
        duration: 0.5,
        fade: true,
        ease: 'power1.inOut',
        onEnter: (elements) =>
          gsap.fromTo(elements, { opacity: 0 }, { opacity: 1 }),
        onLeave: (elements) =>
          gsap.fromTo(elements, { opacity: 1 }, { opacity: 0 }),
      });
    }
  }
}

export default News;
